import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {filter, first, switchMap} from 'rxjs/operators';
import * as fromStore from '../../store';
import {CompanyInfo} from '../../store/actions/company-info.action';

@Injectable()
export class CompanyInfoResolver implements Resolve<CompanyInfo | null> {

  constructor(
    private _store: Store<fromStore.DbStoreState>
  ) {}

  resolve(): Observable<any>|Promise<any>|any {
    return new Promise((resolve: Function, reject: Function): void => {
      this._store.select(fromStore.getCompanyInfoLoaded)
        .pipe(
            filter((loaded: boolean) => loaded),
            switchMap(() => this._store.select(fromStore.getCompanyInfo)),
            first()
        )
        .subscribe((companyInfo: any) => {
          resolve(companyInfo);
        });
    });
  }
}
